import { render, staticRenderFns } from "./404.vue?vue&type=template&id=0b66f601&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=0b66f601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66f601",
  null
  
)

component.options.__file = "404.vue"
export default component.exports